import React from 'react'
import { usStates, caStates } from '../helpers/constants'

// USA states
const usStateCodes = Object.keys(usStates)

export const UsStateSelectOptions = (props) => {
  return (
    <>
      {usStateCodes.map((stateCode) => (
        <option key={stateCode} value={stateCode}>
          {usStates[stateCode]}
        </option>
      ))}
    </>
  )
}

export const getUsStateName = (stateCode: string) => usStates[stateCode]

// Canada provinces
const caStateCodes = Object.keys(caStates)

export const CaStateSelectOptions = (props) => {
  return (
    <>
      {caStateCodes.map((stateCode) => (
        <option key={stateCode} value={stateCode}>
          {caStates[stateCode]}
        </option>
      ))}
    </>
  )
}

export const getCaStateName = (stateCode: string) => caStates[stateCode]
